<template>
	<transition
			appear
			:appear-active-class="$_inpTxtFld_styleInputTextFieldAnimation()">
		<v-row no-gutters>
			<v-col>
				<validation-provider
						:name="'InputTextField-' + contentKey"
						:rules="getValidationRules(contents[contentKey].rules)"
						v-slot="{ errors }">
					<v-text-field
							v-model="$store.state.input.data[contentKey].answer"
							
							:background-color="$_inpTxtFld_styleTextFieldBackgroundColor"
							:clearable="$_inpTxtFld_styleTextFieldClearable"
							:color="$_inpTxtFld_styleTextFieldColor"
							:counter="$_inpTxtFld_styleTextFieldCounter"
							:dark="$_inpTxtFld_styleTextFieldDark"
							:filled="$_inpTxtFld_styleTextFieldFilled"
							:flat="$_inpTxtFld_styleTextFieldFlat"
							:light="$_inpTxtFld_styleTextFieldLight"
							:outlined="$_inpTxtFld_styleTextFieldOutlined"
							:solo="$_inpTxtFld_styleTextFieldSolo"
							:solo-inverted="$_inpTxtFld_styleTextFieldSoloInverted"

							:append-icon="$_inpTxtFld_styleParamAppendIcon(contents[contentKey].params)"
							:append-outer-icon="$_inpTxtFld_styleParamAppendOuterIcon(contents[contentKey].params)"
							:prepend-icon="$_inpTxtFld_styleParamPrependIcon(contents[contentKey].params)"
							:prepend-inner-icon="$_inpTxtFld_styleParamPrependInnerIcon(contents[contentKey].params)"

							:hint="$_inpTxtFld_langParamHint(contents[contentKey].params)"
							:mask="$_inpTxtFld_langParamMask(contents[contentKey].params)"
							:message="$_inpTxtFld_langParamMessage(contents[contentKey].params)"
							:placeholder="$_inpTxtFld_langParamPlaceholder(contents[contentKey].params)"
							:prefix="$_inpTxtFld_langParamPrefix(contents[contentKey].params)"
							:suffix="$_inpTxtFld_langParamSuffix(contents[contentKey].params)"
							:type="$_inpTxtFld_langParamType(contents[contentKey].params)"

							:error-messages="errors" />
				</validation-provider>
			</v-col>
		</v-row>
	</transition>
</template>

<script>
	export default {
		name: 'InputTextField',
		props: {
			contentKey: String,
			contents: Object,
			inits: Object
		},
		computed: {
			// lang
			$_inpTxtFld_langParamHint() {
				const self_ = this;
				return params => {
					if(self_.isFalse(params)) { return null }
					const param_ = params.hint;
					if(self_.isFalse(param_)) { return null }
					return self_.getLangsVal(param_)
				}
			},
			$_inpTxtFld_langParamMask() {
				const self_ = this;
				return params => {
					if(self_.isFalse(params)) { return null }
					const param_ = params.mask;
					if(self_.isFalse(param_)) { return null }
					return self_.getLangsVal(param_)
				}
			},
			$_inpTxtFld_langParamMessage() {
				const self_ = this;
				return params => {
					if(self_.isFalse(params)) { return null }
					const param_ = params.message;
					if(self_.isFalse(param_)) { return null }
					return self_.getLangsVal(param_)
				}
			},
			$_inpTxtFld_langParamPlaceholder() {
				const self_ = this;
				return params => {
					if(self_.isFalse(params)) { return null }
					const param_ = params.placeholder;
					if(self_.isFalse(param_)) { return null }
					return self_.getLangsVal(param_)
				}
			},
			$_inpTxtFld_langParamPrefix() {
				const self_ = this;
				return params => {
					if(self_.isFalse(params)) { return null }
					const param_ = params.prefix;
					if(self_.isFalse(param_)) { return null }
					return self_.getLangsVal(param_)
				}
			},
			$_inpTxtFld_langParamSuffix() {
				const self_ = this;
				return params => {
					if(self_.isFalse(params)) { return null }
					const param_ = params.suffix;
					if(self_.isFalse(param_)) { return null }
					return self_.getLangsVal(param_)
				}
			},
			$_inpTxtFld_langParamType() {
				const self_ = this;
				return params => {
					if(self_.isFalse(params)) { return null }
					const param_ = params.type;
					if(self_.isFalse(param_)) { return null }
					return self_.getLangsVal(param_)
				}
			},
			// style
			$_inpTxtFld_styleInputTextField() {
				const self_ = this;
				return () => {
					if(self_.isEmpty(self_.inits)) { return null }
					return self_.getInitsStyleVal(self_.inits, 'inputTextField')
				}
			},
			$_inpTxtFld_styleInputTextFieldAnimation() {
				const self_ = this;
				return () => {
					const layout_ = self_.$_inpTxtFld_styleInputTextField()
					if(self_.isFalse(layout_)) { return null }
					return self_.getStylesVal(layout_.animation)
				}
			},
			$_inpTxtFld_styleTextField() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'textField')
			},
			$_inpTxtFld_styleTextFieldAppendIcon() {
				const self_ = this;
				const style_ = self_.$_inpTxtFld_styleTextField;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.appendIcon)
			},
			$_inpTxtFld_styleTextFieldAppendOuterIcon() {
				const self_ = this;
				const style_ = self_.$_inpTxtFld_styleTextField;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.appendOuterIcon)
			},
			$_inpTxtFld_styleTextFieldBackgroundColor() {
				const self_ = this;
				const style_ = self_.$_inpTxtFld_styleTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.backgroundColor)
			},
			$_inpTxtFld_styleTextFieldClearable() {
				const self_ = this;
				const style_ = self_.$_inpTxtFld_styleTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.clearable)
			},
			$_inpTxtFld_styleTextFieldColor() {
				const self_ = this;
				const style_ = self_.$_inpTxtFld_styleTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.color)
			},
			$_inpTxtFld_styleTextFieldCounter() {
				const self_ = this;
				const style_ = self_.$_inpTxtFld_styleTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.counter)
			},
			$_inpTxtFld_styleTextFieldDark() {
				const self_ = this;
				const style_ = self_.$_inpTxtFld_styleTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.dark)
			},
			$_inpTxtFld_styleTextFieldFilled() {
				const self_ = this;
				const style_ = self_.$_inpTxtFld_styleTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.filled)
			},
			$_inpTxtFld_styleTextFieldFlat() {
				const self_ = this;
				const style_ = self_.$_inpTxtFld_styleTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.flat)
			},
			$_inpTxtFld_styleTextFieldLight() {
				const self_ = this;
				const style_ = self_.$_inpTxtFld_styleTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.light)
			},
			$_inpTxtFld_styleTextFieldOutlined() {
				const self_ = this;
				const style_ = self_.$_inpTxtFld_styleTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.outlined)
			},
			$_inpTxtFld_styleTextFieldPrependIcon() {
				const self_ = this;
				const style_ = self_.$_inpTxtFld_styleTextField;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.prependIcon)
			},
			$_inpTxtFld_styleTextFieldPrependInnerIcon() {
				const self_ = this;
				const style_ = self_.$_inpTxtFld_styleTextField;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.prependInnerIcon)
			},
			$_inpTxtFld_styleTextFieldSolo() {
				const self_ = this;
				const style_ = self_.$_inpTxtFld_styleTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.solo)
			},
			$_inpTxtFld_styleTextFieldSoloInverted() {
				const self_ = this;
				const style_ = self_.$_inpTxtFld_styleTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.soloInverted)
			},
			$_inpTxtFld_styleParamAppendIcon() {
				const self_ = this;
				return params => {
					if(self_.isFalse(params)) { return null }
					const param_ = params.appendIcon;
					if(self_.isFalse(param_)) { return null }
					return self_.getStylesVal(param_)
				}
			},
			$_inpTxtFld_styleParamAppendOuterIcon() {
				const self_ = this;
				return params => {
					if(self_.isFalse(params)) { return null }
					const param_ = params.appendOuterIcon;
					if(self_.isFalse(param_)) { return null }
					return self_.getStylesVal(param_)
				}
			},
			$_inpTxtFld_styleParamPrependIcon() {
				const self_ = this;
				return params => {
					if(self_.isFalse(params)) { return null }
					const param_ = params.prependIcon;
					if(self_.isFalse(param_)) { return null }
					return self_.getStylesVal(param_)
				}
			},
			$_inpTxtFld_styleParamPrependInnerIcon() {
				const self_ = this;
				return params => {
					if(self_.isFalse(params)) { return null }
					const param_ = params.prependInnerIcon;
					if(self_.isFalse(param_)) { return null }
					return self_.getStylesVal(param_)
				}
			}
		}		
	}
</script>

<style scoped>
</style>
